class ArticlesInventoryAPI {
    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                console.log("Success Response");
                break;
        }
    }

    async listarTipoInventario() {
        let datos = [];
        let url = `${process.env.REACT_APP_PUBLIC_URL}inventario-tipos/listar`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
            console.log(error);
        });
        return datos;
    }

}

export default new ArticlesInventoryAPI();